import React, { useEffect, useRef, useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Flex, Input, Tag, theme, Tooltip } from 'antd';
import './style.css'
import { IoClose } from 'react-icons/io5';

const tagInputStyle = {
  width: 64,
  height: 22,
  marginInlineEnd: 8,
  verticalAlign: 'top',
};

const TagGenerator = (props) => {
  const { onChange, limit } = props

  const { token } = theme.useToken();

  const [tags, setTags] = useState([]);
  const [inputVisible, setInputVisible] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [editInputIndex, setEditInputIndex] = useState(-1);
  const [editInputValue, setEditInputValue] = useState('');
  const [editData, setEditData] = useState(props?.onEdit())

  const inputRef = useRef(null);
  const editInputRef = useRef(null);

  useEffect(() => {
    if (inputVisible) {
      inputRef.current?.focus();
    }
  }, [inputVisible]);

  useEffect(() => {
    editInputRef.current?.focus();
  }, [editInputValue]);

  const handleClose = (removedTag) => {
    const newTags = tags.filter((tag) => tag !== removedTag);
    setTags(newTags);
  };

  const showInput = () => {
    setInputVisible(true);
  };

  const handleInputChange = (e) => {
    if (inputValue.length < 20) {
      setInputValue(e.target.value);
    }
  };

  const handleInputConfirm = () => {
    if (inputValue && !tags.includes(inputValue)) {
      setTags([...tags, inputValue]);
    }
    setInputVisible(false);
    setInputValue('');
  };

  const handleEditInputChange = (e) => {
    if (editInputValue.length < 20) {
      setEditInputValue(e.target.value);
    }
  };

  const handleEditInputConfirm = () => {
    const newTags = [...tags];
    newTags[editInputIndex] = editInputValue;
    setTags(newTags);
    setEditInputIndex(-1);
    setEditInputValue('');
  };

  const tagPlusStyle = {
    height: 22,
    background: token.colorBgContainer,
    borderStyle: 'dashed',
  };

  useEffect(() => {
    if (onChange) {
      onChange(tags)
    }
  }, [tags]);

  useEffect(() => {
    if (editData) {
      setTags([])
      setTags(editData.map(item => item.tag))
    }
  }, [editData])


  return (
    <Flex gap="4px 0" wrap id='tag-generator'>
      {tags.slice(0, limit).map((tag, index) => {
        if (editInputIndex === index) {
          return (
            <Input
              ref={editInputRef}
              key={tag}
              size="small"
              style={tagInputStyle}
              value={editInputValue}
              onChange={handleEditInputChange}
              onDoubleClick={handleEditInputConfirm}
              onPressEnter={handleEditInputConfirm}
              maxLength={20}
              suffix={
                <React.Fragment>
                  <span className={`${!editInputValue.length && 'pointer-events-none'}`}>
                    <IoClose
                      className={`
                            text-md 
                            cursor-pointer
                            text-slate-600
                        `}
                      onClick={() => setEditInputValue('')}
                    />
                  </span>
                </React.Fragment>
              }

            />
          );
        }
        const isLongTag = tag.length > 20;
        const tagElem = (
          <Tag
            key={tag}
            closable={true}
            style={{
              userSelect: 'none',
              backgroundColor: '#FEEDBF'
            }}
            onClose={() => handleClose(tag)}
          >
            <span
              onDoubleClick={(e) => {
                // if (index !== 0) {
                setEditInputIndex(index);
                setEditInputValue(tag);
                e.preventDefault();
                // }
              }}
            >
              {isLongTag ? `${tag.slice(0, 20)}...` : tag}
            </span>
          </Tag>
        );
        return isLongTag ? (
          <Tooltip title={tag} key={tag}>
            {tagElem}
          </Tooltip>
        ) : (
          tagElem
        );
      })}
      {inputVisible ? (
        <Input
          ref={inputRef}
          type="text"
          size="small"
          style={tagInputStyle}
          value={inputValue}
          onChange={handleInputChange}
          onDoubleClick={handleInputConfirm}
          onPressEnter={handleInputConfirm}
          maxLength={20}
          suffix={
            <React.Fragment>
              <span className={`${!inputValue.length && 'pointer-events-none'}`}>
                <IoClose
                  className={`
                      text-md 
                      cursor-pointer 
                      text-slate-600
                  `}
                  onClick={() => setInputValue('')}
                />
              </span>
            </React.Fragment>
          }
        />
      ) : (
        <Tag 
          className={`${tags.length >= limit && 'pointer-events-none opacity-20'}`} 
          style={tagPlusStyle} 
          icon={<PlusOutlined />} 
          onClick={showInput}
        >
          New Tag
        </Tag>
      )}
    </Flex>
  );
};
export default TagGenerator;
